import lang from 'vars/lang';

const logError = (errorMessage: string): void =>
  // eslint-disable-next-line no-console
  console.error(errorMessage ?? lang.errors.unspecified);

export default logError;
